import { useSelector } from "react-redux";
import { RootState } from "./store";
import { useEffect } from "react";
import React from "react";
import { useMsal } from "@azure/msal-react";
import { loginRequest } from "./msalConfig";
import {
  getUserLogin,
  resetUserLogin,
  resetUserLoginError,
} from "./store/slices/UserLogoutSlice";
import { useAppDispatch } from "./store/hooks";
import { MotifProgressLoader } from "@ey-xd/motif-react";
import Login from "./pages/Login";
import {
  getAccessTokenFromLocal,
  notifyLoginAcrossTabs,
  setAccessTokenInLocal,
} from "./utils/common";
import { setLoginInProgress, setLoginPromise } from "./utils/httpClient";
import { useNavigate } from "react-router";
interface LoginValidationProps {
  setAuthReady: React.Dispatch<React.SetStateAction<boolean>>;
  loginInProgress: boolean;
  setIsLoginInprogress: React.Dispatch<React.SetStateAction<boolean>>;
}

export function LoginValidation({
  setAuthReady,
  loginInProgress,
  setIsLoginInprogress,
}: LoginValidationProps) {
  const [verifyLogin, setVerifyLogin] = React.useState<boolean>(false);
  const [loginError, setLoginError] = React.useState<boolean>(false);
  const [accessToken, setAccessToken] = React.useState<string>("");
  const ACCESS_TOKEN = getAccessTokenFromLocal();
  const dispatch = useAppDispatch();
  const nav = useNavigate();
  const isLogin = useSelector(
    (state: RootState) => state.UserLogoutSlice.isLogin,
  );
  const { instance } = useMsal();

  useEffect(() => {
    const handleLogin = async () => {
      if (!isLogin && !loginError) {
        const hasMsalAccount = instance.getAllAccounts().length > 0;
        if (
          !ACCESS_TOKEN ||
          ACCESS_TOKEN === "" ||
          ACCESS_TOKEN === null ||
          !hasMsalAccount
        ) {
          let loginResponse;
          try {
            setIsLoginInprogress(true);
            loginResponse = await instance.loginPopup(loginRequest);
          } catch (err) {
            console.log("Login not successful", err);
            setLoginError(true);
            return;
          }
          setAccessToken(loginResponse?.accessToken || "");
          setAccessTokenInLocal(loginResponse?.accessToken || "");

          let resolveLogin: () => void;
          const promise = new Promise<void>((resolve) => {
            resolveLogin = resolve;
          });
          setLoginInProgress(true);
          setLoginPromise(promise);

          const loginApiResponse = await dispatch(getUserLogin());
          setLoginInProgress(false);
          resolveLogin!();

          if (
            loginApiResponse.type === "UserLogoutSlice/getUserLogin/fulfilled"
          ) {
            notifyLoginAcrossTabs();
            setAuthReady(true);
            setVerifyLogin(true);
            dispatch(resetUserLogin());
            setIsLoginInprogress(false);
            nav(sessionStorage.getItem("redirectTo") || "/");
          } else {
            setAuthReady(false);
            setVerifyLogin(true);
            setLoginError(true);
            dispatch(resetUserLoginError());
            setIsLoginInprogress(false);
            return;
          }
        } else {
          setAuthReady(true);
          setVerifyLogin(true);
          dispatch(resetUserLogin());
          setIsLoginInprogress(false);
        }
      }
    };
    handleLogin();
  }, [
    ACCESS_TOKEN,
    accessToken,
    dispatch,
    instance,
    isLogin,
    loginError,
    setAuthReady,
    verifyLogin,
  ]);

  if (
    (!verifyLogin && !loginError) ||
    !ACCESS_TOKEN ||
    ACCESS_TOKEN === "" ||
    ACCESS_TOKEN === null
  ) {
    return (
      <MotifProgressLoader show={!verifyLogin} className="initial-loader" />
    );
  }
  if (loginError) {
    return (
      <>
        <Login
          setVerifyLogin={setVerifyLogin}
          setLoginError={setLoginError}
          loginInProgress={loginInProgress}
          setIsLoginInprogress={setIsLoginInprogress}
        />
      </>
    );
  }

  return <></>;
}
